
import React, { useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Container,
  CssBaseline,
  Paper,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
  CircularProgress,
  Link
} from "@mui/material";

import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

import { useNavigate, Link as RouterLink } from "react-router-dom";
import api from "../utils/api";

export default function Register() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [showPw, setShowPw] = useState(false);
  const [error, setError] = useState("");

  function change(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError("");
  }

  async function submit(e) {
    e.preventDefault();
    try {
      await api.post("/auth/register", form);
      alert("Registered successfully. Please log in.");
      navigate("/login");
    } catch (err) {
      setError(err.response?.data?.message || "Registration failed");
    }
  }

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <CssBaseline />

      <Paper
        elevation={6}
        sx={{
          p: 4,
          borderRadius: 4,
          textAlign: "center",
        }}
      >
        <Avatar
          sx={{
            bgcolor: "#1976d2",
            width: 56,
            height: 56,
            mx: "auto",
            mb: 2,
          }}
        >
          <PersonAddAltIcon fontSize="large" />
        </Avatar>

        <Typography variant="h5" fontWeight={700}>
          Create account
        </Typography>

        <Typography sx={{ mb: 3 }} color="text.secondary">
          Join SiteWorks — manage leads, BOQ & projects.
        </Typography>

        <Box component="form" onSubmit={submit}>
          <TextField
            fullWidth
            label="Full name"
            name="name"
            margin="normal"
            onChange={change}
          />

          <TextField
            fullWidth
            label="Email"
            name="email"
            margin="normal"
            onChange={change}
            sx={{
              "& .MuiOutlinedInput-root": { bgcolor: "#eef5ff" },
            }}
          />

          <TextField
            fullWidth
            label="Password"
            name="password"
            margin="normal"
            type={showPw ? "text" : "password"}
            onChange={change}
            sx={{
              "& .MuiOutlinedInput-root": { bgcolor: "#eef5ff" },
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPw(!showPw)}>
                    {showPw ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          {error && (
            <Typography color="error" sx={{ mt: 1 }}>
              {error}
            </Typography>
          )}

          <Button
            fullWidth
            variant="contained"
            sx={{
              mt: 3,
              py: 1.5,
              fontSize: "16px",
              fontWeight: 600,
              bgcolor: "#1976d2",
            }}
            type="submit"
          >
            CREATE ACCOUNT
          </Button>

          <Typography sx={{ mt: 2 }}>
            Already have an account?{" "}
            <Link component={RouterLink} to="/login">
              Sign in
            </Link>
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}
